import { useFeatureFlag } from "context/FeatureFlagsContext";
import { Link } from "react-router-dom";
import logoImage from "components/website/img/stippl-logo--impact.svg";
import { REGISTER_URL } from "../constants";

export function Header() {
	const pricingEnabled = useFeatureFlag("PRICING_ENABLED");
	return (
		<header className="bg-[#0A0E27] border-b border-white/10 sticky top-0 z-50">
			<div className="container mx-auto px-6 py-4">
				<div className="flex items-center justify-between">
					<div className="flex items-center gap-12">
						<Link to="/" className="flex items-center">
							<img src={logoImage} alt="Stippl" style={{ height: 26 }} />
						</Link>

						<nav className="hidden md:flex items-center gap-8">
							{pricingEnabled && (
								<Link to="/pricing" className="text-sm font-medium text-white/90 hover:text-white transition-colors">
									Pricing
								</Link>
							)}
							<Link to="/faq" className="text-sm font-medium text-white/90 hover:text-white transition-colors">
								FAQ
							</Link>
						</nav>
					</div>

					<div className="flex items-center gap-6">
						<a href="/login" className="text-sm font-medium text-white/90 hover:text-white transition-colors">
							Log in
						</a>
						<a
							href={REGISTER_URL}
							target="_blank"
							rel="noopener noreferrer"
							className="inline-flex items-center justify-center rounded-md text-sm font-semibold px-4 py-2 bg-[#8B5CF6] hover:bg-[#7C3AED] text-white shadow-lg shadow-[#8B5CF6]/30 hover:shadow-xl hover:shadow-[#8B5CF6]/40 hover:scale-105 transition-all duration-300"
							style={{
								boxShadow: "0 0 20px rgba(139, 92, 246, 0.4), 0 4px 12px rgba(139, 92, 246, 0.3)",
							}}
						>
							Start free trial
						</a>
					</div>
				</div>
			</div>
		</header>
	);
}
